import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { KpiModule } from '../kpi/kpi.module';
import { CashierFieldComponent, CashierSectionComponent, CashierSummaryComponent } from './cashier-summary.component';

@NgModule({
  declarations: [CashierSummaryComponent, CashierFieldComponent, CashierSectionComponent],
  imports: [CommonModule, KpiModule],
  exports: [CashierSummaryComponent, CashierFieldComponent, CashierSectionComponent, KpiModule]
})
export class CashierSummaryModule { }
